// extracted by mini-css-extract-plugin
export default {"concept":"styles_concept__e2vhA","title":"styles_title__czXTf","list":"styles_list__bUs0v","item":"styles_item__ioz7r"};